import React from "react";
import { useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { Button, Row, Space } from "@masterteam/mt-design-react";
import moment from "moment";

import "./style.scss";
import { Field } from "../KPIWizard/Wizard";

import { ReactComponent as DeleteIcon } from "../../assets/images/delete.svg";

function CustomKPIMeasures({ isReadOnly = false, kpiMeasures = null }) {
  const intl = useIntl();
  const { errors, setFieldValue, values } = useFormikContext();
  const list = isReadOnly && kpiMeasures ? kpiMeasures : values.KPIMeasures;

  if (isReadOnly && kpiMeasures)
    return (
      <Space
        direction="vertical"
        size="small"
        className="custom-kpi-measures-container"
      >
        {list?.map((item, index) => (
          <Row size="small" key={`measure-row-${index}`} align="center">
            <Field
              disabled
              type="number"
              error={errors.KPIMeasures?.[index]?.Target}
              label={intl.formatMessage({ id: "common.target" })}
              inputProps={{
                value: item.Target,
              }}
              hideErrorMessage
            />

            <Field
              type="date"
              label={intl.formatMessage({ id: "common.due-date" })}
              disabled
              hideErrorMessage
              inputProps={{
                value: item.DueDate,
              }}
            />
          </Row>
        ))}
      </Space>
    );

  return (
    <Space
      direction="vertical"
      size="medium"
      className="custom-kpi-measures-container"
    >
      <Space
        direction="vertical"
        size="small"
        className="custom-kpi-measures-container"
      >
        {values.KPIMeasures?.map((item, index) => (
          <Row size="small" key={`measure-row-${index}`} align="center">
            <Field
              name={`KPIMeasures[${index}].Target`}
              disabled={isReadOnly}
              type="number"
              error={errors.KPIMeasures?.[index]?.Target}
              label={intl.formatMessage({ id: "common.target" })}
              inputProps={{
                min: 0,
                step: "any",
                onKeyDown: (event) => {
                  if (
                    event.key === "e" ||
                    event.key === "-" ||
                    event.key === "+"
                  ) {
                    event.preventDefault();
                  }
                },
                onChange: (e) => {
                  const value = e.target.value;
                  setFieldValue(`KPIMeasures[${index}.Target]`, value);
                },

                error: errors.KPIMeasures?.[index]?.Target,
              }}
              hideErrorMessage
              required
            />

            <Field
              type="date"
              label={intl.formatMessage({ id: "common.due-date" })}
              name={`KPIMeasures[${index}].DueDate`}
              disabled={
                isReadOnly || values?.HasNoTarget || values?.HasNoBaseline
              }
              hideErrorMessage
              required
              inputProps={{
                error: errors.KPIMeasures?.[index]?.DueDate,
                minDate:
                  index - 1 >= 0 && values?.KPIMeasures[index - 1]?.DueDate
                    ? moment(values.KPIMeasures[index - 1].DueDate)
                        .add(1, "day")
                        .toDate()
                    : null,

                maxDate:
                  index + 1 <= values?.KPIMeasures?.length &&
                  values?.KPIMeasures[index + 1]?.DueDate
                    ? moment(values.KPIMeasures[index + 1].DueDate)
                        .subtract(1, "day")
                        .toDate()
                    : null,
                onChange: (e) => {
                  setFieldValue(`KPIMeasures[${index}].DueDate`, e);
                },
              }}
            />

            {isReadOnly ? null : (
              <div className="delete-measure-button-wrapper">
                <Button
                  shape="circle"
                  variant="error"
                  fill="none"
                  Icon={DeleteIcon}
                  onClick={() => {
                    setFieldValue(
                      "KPIMeasures",
                      values.KPIMeasures.filter(
                        (measure, measureIndex) => measureIndex !== index
                      )
                    );
                  }}
                  disabled={isReadOnly}
                  size="large"
                  className="delete-measure-button"
                />
              </div>
            )}
          </Row>
        ))}
      </Space>

      {isReadOnly ? null : (
        <Button
          type="primary"
          className="add-measure-button"
          disabled={isReadOnly}
          onClick={() =>
            setFieldValue("KPIMeasures", [
              ...values.KPIMeasures,
              {
                Target: "",
                DueDate: null,
                Year: null,
                IsEditable: true,
                ItemIndex: values.KPIMeasures?.length
                  ? values.KPIMeasures.length
                  : 0,
              },
            ])
          }
        >
          {intl.formatMessage({ id: "common.add" })}
        </Button>
      )}
    </Space>
  );
}

export default CustomKPIMeasures;
